var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionNetwork } from "./actionNetwork";
var initial = {};
export var reducerNetwork = function (state, action) {
    if (state === void 0) { state = initial; }
    var _a, _b;
    switch (action.type) {
        case TypeActionNetwork.Connected:
            return __assign({}, state, (_a = {}, _a[action.id + "_online"] = true, _a));
        case TypeActionNetwork.Disconnected:
            return __assign({}, state, (_b = {}, _b[action.id + "_online"] = false, _b));
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/network/reducerNetwork.ts
// module id = 2965
// module chunks = 3